import React from 'react'
import {Form, Alert} from 'antd';

class Consent extends React.Component {
  render() {
    return (
      <div className="form-group">
        <div className="form-group-details">
            <h4>Consent Process - Error occured</h4>
            <Alert
              message="Error"
              style={{textAlign: 'left'}}
              description="Consent document already signed or link has expired."
              type="error"
              showIcon
            />
        </div>
      </div>
    );
  }
}


const ConsentForm = Form.create()(Consent);

export default ConsentForm;



// WEBPACK FOOTER //
// ./src/components/ConsentError/ConsentForm.js